import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { OfferAndAppointmentComponent } from '../offer-and-appointment/offer-and-appointment.component';
import { Config } from 'src/app/app-constant';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { AddDeptLocComponent } from '../add-dept-loc/add-dept-loc.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatText, formatYearRanges } from 'src/app/shared/commen-function-file';
import { filter } from 'rxjs';
import { FilterType } from 'angular-google-charts';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-employee-application-form',
  templateUrl: './employee-application-form.component.html',
  styleUrls: ['./employee-application-form.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EmployeeApplicationFormComponent implements OnInit {

  userName: any | null;
  loggedInUserRole: any | null;
  companyLogo: any | null;
  buttonColorName: any;

  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any;
  employeeForm: any;
  candidateDetails: any;
  newCategory: any;
  selectedYearForCompetency: any;
  pmsYears: any;
  loggedInUserId: any;
  setPrefix: any;
  setLimit: any;
  isManual: any;
  currentDate: any;
  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmployeeApplicationFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {
    this.currentDate = (new Date()).toISOString();
    this.candidateDetails = data.candidateId;
    console.log(this.candidateDetails);


    this.employeeForm = this.fb.group({
      // General Information
      salutation: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      genders: ['', Validators.required],
      country: ['', Validators.required],
      presentAddress: ['',Validators.required],
      permanentAddress: [''],
      maritalStatus: [''],
      dateOfBirth: ['', Validators.required],
      age: ['', Validators.required],
      personalEmail: ['', [Validators.email]],
      aadhaarCardNo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      panNo: ['', [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')]],
      unaNo: [''],
      mobileNo: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],

      previousExperience: ['',],
      emergencyContact: ['', [Validators.pattern('^[0-9]{10}$')]],
      bloodGroup: [''],
      fathersName: [''],
      mothersName: [''],
      spouseName: [''],
      noOfChildren: [''],
      relativeWorking: [''],

      // Education Related Information
      highestEducation: [''],
      highestEducationInstitute: [''],
      highestEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      highestEducationMarks: [''],
      secondEducation: [''],
      secondEducationInstitute: [''],
      secondEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      secondEducationMarks: [''],
      thirdEducation: [''],
      thirdEducationInstitute: [''],
      thirdEducationYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      thirdEducationMarks: [''],
      highestProfessional: [''],
      highestProfessionalInstitute: [''],
      highestProfessionalYear: ['', [Validators.pattern('^[0-9]{4}$')]],
      highestProfessionalMarks: [''],

      // Prior Employment Related Information
      lastOrganisation: [''],
      lastOrganisationJoiningDate: [''],
      lastOrganisationLastWorkingDate: [''],
      lastOrganisationDepartment: [''],
      lastOrganisationDesignation: [''],
      lastToLastOrganisation: [''],
      lastToLastOrganisationJoiningDate: [''],
      lastToLastOrganisationLastWorkingDate: [''],
      lastToLastOrganisationDepartment: [''],
      lastToLastOrganisationDesignation: [''],
      anyOtherOrganisation: [''],
      anyOtherOrganisationJoiningDate: [''],
      anyOtherOrganisationLastWorkingDate: [''],
      anyOtherOrganisationDepartment: [''],
      anyOtherOrganisationDesignation: [''],

      //---------------------------------HR ------------------------------------------
      companyId: [''],
      candidateId: [''],

      employmentCategory: ['', Validators.required],
      employmentType: ['', Validators.required],
      retirementAge: ['',],
      empStatus: ['', Validators.required],
      dateOfJoining: ['', Validators.required],
      groupName: ['', Validators.required],
      companyName: ['', Validators.required],
      reportingManagerName: ['', Validators.required],
      reportingManagerCode: ['', Validators.required],
      dottedReportingManagerName: ['',],
      dottedReportingManagerCode: ['',],
      hodName: ['', Validators.required],
      hodCode: ['', Validators.required],
      band: ['', Validators.required],
      grade: ['', Validators.required],
      designation: ['', Validators.required],
      department: ['', Validators.required],
      subDepartment: ['',],
      workLocationState: ['', Validators.required],
      workLocationCity: ['', Validators.required],
      designationAtDoj: ['', Validators.required],
      noOfPromotions: ['',],
      currentPerformanceScore: ['',],
      currentPerformanceRating: ['',],
      lastYearPerformanceScore: ['',],
      lastYearPerformanceRating: ['',],
      yearBeforeLastYearPerformanceScore: ['',],
      yearBeforeLastYearPerformanceRating: ['',],
      mailBody: ['',],
      mailSubject: ['',],
      //------------------------------------------------current --------------------------------------
      currency: [''],
      salaryStatus: ['', Validators.required],
      bankName: ['', Validators.required],
      bankBranchAddress: ['', Validators.required],
      bankAccount: ['', Validators.required],
      ifscCode: ['', [Validators.required]],

      basicSalaryPm: ['', Validators.required],
      daPm: [''],
      hraPm: [''],
      otherAllowancePm: [''],
      ltaPm: [''],
      medicalAllowancePm: [''],
      washingAllowancePm: [''],
      specialAllowancePm: [''],
      fuelAllowancePm: [''],
      entertainmentAllowancePm: [''],
      educationAllowancePm: [''],
      booksAllowancePm: [''],
      statutoryBonusPm: [''],
      anyOtherAllowancePm: [''],
      grossSalaryPm: ['', Validators.required],
      employeePfPm: [''],
      employerPfPm: [''],
      ptPm: [''],
      lwfPm: [''],
      esicPm: [''],
      otherRetiralPm: [''],
      totalRetiralPm: ['', Validators.required],
      totalCTCIncludingRetiralPM: ['', Validators.required],
      totalCTCIncludingRetiralPA: ['', Validators.required],
      processOfVp: ['', Validators.required],
      annualVariablePayBudget: [''],
      annualTotalCtc: ['', Validators.required],
      incrementOn: ['', Validators.required]
    });


  }

  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault(); // Prevents the default enter key behavior
  }

  formatedataVariable = formatText;
  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getpmsyearlist();


  }
  salutations = ['Mr.', 'Ms.', 'Mrs.', 'Dr.'];
  employmentCategories: string[] = ['Staff', 'Worker', 'Contractual', 'Trainee'];
  selectedCategory: any;
  employmentTypes: string[] = ['Probation', 'Confirmed'];
  selectedEmploymentType: any; // Holds the selected value
  employmentstatus: any[] = ['Active']
  selectedEmploymentstatus: any;
  salaryStatuses: string[] = ['Process', 'Hold', 'FF'];
  selectedSalaryStatus: string = ''; // Holds the selected value
  vpProcesses: { id: string; name: string }[] = [
    { id: 'VP_ADJUSTED_TO_PERFORMANCE', name: 'Fixed VP' },
    { id: 'NO_VP', name: 'No VP' },
    { id: 'PERCENT_OF_CTC_BASED_ON_RATING', name: '%ge on CTC' }
  ];

  incrementOnOptions: string[] = [
    'Fixed_Annual_CTC',
    'Total_Annual_CTC'
  ];
  selectedIncrementOn: string = '';
  selectedVPProcess: string = ''; // Holds the selected value
  bloodGroups: string[] = [
    'A+',
    'A-',
    'B+',
    'B-',
    'AB+',
    'AB-',
    'O+',
    'O-'
  ];
  subDepartmentList = ['HR', 'Finance', 'Engineering', 'Marketing'];
  stateList = ['New York', 'California', 'Texas', 'Florida'];
  ratingList = ['Excellent', 'Good', 'Average', 'Below Average', 'Poor'];
  hodList = [
    { name: 'Alice Johnson', code: 'AJ001' },
    { name: 'Bob Williams', code: 'BW002' }
  ];
  bandList = ['Band 1', 'Band 2', 'Band 3'];
  gradeList = ['Grade A', 'Grade B', 'Grade C'];
  designationList = ['Manager', 'Senior Manager', 'Director'];
  managersList = [
    { name: 'John Doe', code: 'JD001' },
    { name: 'Jane Smith', code: 'JS002' }
  ];

  currencyList = [
    { value: 'USD', label: 'US Dollar (USD)' },
    { value: 'EUR', label: 'Euro (EUR)' },
    { value: 'GBP', label: 'British Pound (GBP)' },
    { value: 'INR', label: 'Indian Rupee (INR)' },
    { value: 'JPY', label: 'Japanese Yen (JPY)' },
    { value: 'AUD', label: 'Australian Dollar (AUD)' },
    { value: 'CAD', label: 'Canadian Dollar (CAD)' }
  ];


  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;



  //         // var test = ele?.year?.split('-');
  //         // this.fromYear = test[0];
  //         // this.toYear = test[1];
  //       }
  //     });
  //     this.getListCandidate();
  //     this.callAppdd();
  //     setTimeout(() => {

  //       this.getEmployeeList();
  //     }, 100)




  //   });
  // }
  preventNegativeValues(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e' || event.key === 'E') {
      event.preventDefault(); // Stops "-" and "e/E" from being typed
    }
  }
  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
    // Additional function calls
    this.getListCandidate();
    this.callAppdd();
    setTimeout(() => {

      this.getEmployeeList();
    }, 100)
    });
  }
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
    this.selectedYearForCompetency = selectedYearObj ?.year;
      let test = selectedYearObj?.year.split('-');
       
  }
}
  filteredEmployees: any;
  employeeData: any;
  candidateGeneralAndSalaryinfo: any = [];
  candidateGeneralAndSalaryinfowithoutgeneralinfo: boolean = false;
  getListCandidate() {
    this.httpService.callGetService(`${this.config.getListbyCandidateIdAndCompanyId}?candidateId=${this.candidateDetails.candidateId}&companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      this.candidateGeneralAndSalaryinfo = data.data;
      console.log(data.data);

      this.candidateGeneralAndSalaryinfowithoutgeneralinfo =
        data.data.currentEmploymentFormByHR?.length > 0 &&
        data.data.candidateSalaryInformation?.length > 0;


      console.log(this.candidateGeneralAndSalaryinfowithoutgeneralinfo);

    })
  }
  getEmployeeList() {
    this.httpService.callGetService(`${this.config.candidateList}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      this.filteredEmployees = record.data;


      let filterrecord = this.filteredEmployees.filter((record: any) => record.candidateId === this.candidateDetails.candidateId); // Initialize filtered list

      this.employeeData = filterrecord[0];


      let ForReportingManager = this.assignReporteesDropdown?.find((record: any) => record.id == this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.reportingManagerName);
      let ForHodName = this.assignReporteesDropdown?.find((record: any) => record.id == this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.hodName);


      if (this.candidateDetails) {
        this.employeeForm.patchValue({
          candidateId: this.employeeData?.record?.candidateId,
          salutation: this.candidateDetails?.salutation || '',
          firstName: this.candidateDetails?.firstName || '',
          lastName: this.candidateDetails?.lastName || '',
          genders: this.employeeData?.gender || '',
          country: this.employeeData?.country || '',
          presentAddress: this.employeeData?.address || '',
          permanentAddress: this.employeeData?.permanentAddress || '',
          maritalStatus: this.employeeData?.maritalStatus || '',
          dateOfBirth: this.employeeData?.dateOfBirth || '',
          age: this.employeeData?.age || '',
          personalEmail: this.candidateDetails?.candidateEmail || '',
          aadhaarCardNo: this.employeeData?.aadharNo || '',
          panNo: this.employeeData?.panNo || '',
          unaNo: this.employeeData?.uan || '',
          mobileNo: this.employeeData?.contactNo || '',
          previousExperience: this.employeeData?.totalExperience || '',
          emergencyContact: this.employeeData?.emergencyContactNo || '',
          bloodGroup: this.employeeData?.bloodGroup || '',
          fathersName: this.employeeData?.fathersName || '',
          mothersName: this.employeeData?.mothersName || '',
          spouseName: this.employeeData?.spouseName || '',
          noOfChildren: this.employeeData?.noOfChildren || '',
          relativeWorking: this.employeeData?.isRelativeWorking ? 'Yes' : 'No',
          highestEducation: this.employeeData?.highestEducationQualification,
          highestEducationInstitute: this.employeeData?.highestEducationInstitute || '',
          highestEducationMarks: this.employeeData?.highestEducationMarks || '',
          highestEducationYear: this.employeeData?.highestEducationYearOfPassing || '',
          secondEducation: this.employeeData?.secondEducation,
          secondEducationInstitute: this.employeeData?.highestEducationInstitute2 || '',
          secondEducationMarks: this.employeeData?.highestEducationMarks2 || '',
          secondEducationYear: this.employeeData?.highestEducationYearOfPassing2 || '',
          thirdEducation: this.employeeData?.highestEducationQualification3,
          thirdEducationInstitute: this.employeeData?.highestEducationInstitute3 || '',
          thirdEducationMarks: this.employeeData?.highestEducationMarks3 || '',
          thirdEducationYear: this.employeeData?.highestEducationYearOfPassing3 || '',

          highestProfessionalInstitute: this.employeeData?.highestProfessionalInstitute || '',
          highestProfessionalMarks: this.employeeData?.highestProfessionalMarks || '',
          highestProfessional: this.employeeData?.highestProfessionalQualification || '',
          highestProfessionalYear: this.employeeData?.highestProfessionalYearOfPassing || '',
          lastOrganisation: this.employeeData?.lastToLastOrganisationName,

          lastOrganisationDepartment: this.employeeData?.lastOrganisationDepartment,
          lastOrganisationDesignation: this.employeeData?.lastOrganisationDesignation,
          lastOrganisationJoiningDate: this.employeeData?.lastOrganisationDoj,
          lastOrganisationLastWorkingDate: this.employeeData?.lastOrganisationLwd,
          // lastToLastOrganisation: this.employeeData?.lastOrganisationName,
          lastToLastOrganisationDepartment: this.employeeData?.lastToLastOrganisationDepartment,
          lastToLastOrganisationDesignation: this.employeeData?.lastToLastOrganisationDesignation,
          lastToLastOrganisationJoiningDate: this.employeeData?.lastToLastOrganisationDoj,
          lastToLastOrganisationLastWorkingDate: this.employeeData?.lastToLastOrganisationLwd,
          lastToLastOrganisation: this.employeeData?.lastToLastOrganisationName,
          anyOtherOrganisation: this.employeeData?.otherOrganisationName,
          anyOtherOrganisationJoiningDate: this.employeeData?.otherOrganisationDoj,
          anyOtherOrganisationLastWorkingDate: this.employeeData?.otherOrganisationLwd,
          anyOtherOrganisationDepartment: this.employeeData?.otherOrganisationDepartment,
          anyOtherOrganisationDesignation: this.employeeData?.otherOrganisationDesignation,


          //-----------------------------------------------------------hr--------------------------------------------------------------
          employmentCategory: this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.employmentCategory,
          employmentType:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.employmentType,
          retirementAge:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.retirementAge,
          empStatus:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.empStatus||'Active',
          dateOfJoining:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dateOfJoining,
          groupName:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.groupName,
          companyName:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.companyName,
          reportingManagerName: ForReportingManager ? ForReportingManager?.name :this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.reportingManagerName,
          // reportingManagerName:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?String(this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR?.reportingManagerName):null,
          reportingManagerCode:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.reportingManagerCode,
          dottedReportingManagerName:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dottedReportingManagerName,
          dottedReportingManagerCode:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.dottedReportingManagerCode,
          hodName: ForHodName ? ForHodName?.name :this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.hodName,
          hodCode:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.hodCode,
          band:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.band,
          grade:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.grade,
          designation:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.designation,
          department:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.department,
          subDepartment:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.subDepartment,
          workLocationState:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.workLocationState,
          workLocationCity:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.workLocationCity,
          designationAtDoj:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.designationAtDoj,
          noOfPromotions:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.noOfPromotions,
          currentPerformanceScore:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.currentPerformanceScore,
          currentPerformanceRating:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.currentPerformanceRating,
          lastYearPerformanceScore:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.lastYearPerformanceScore,
          lastYearPerformanceRating:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.lastYearPerformanceRating,
          yearBeforeLastYearPerformanceScore:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.yearBeforeLastYearPerformanceScore,
          yearBeforeLastYearPerformanceRating:this.candidateGeneralAndSalaryinfo?.currentEmploymentFormByHR[0]?.yearBeforeLastYearPerformanceRating,

          //.............................................................saraly info.......................................................................

          currency:  this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.currency,
          salaryStatus: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.salaryStatus,
          bankName: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankName,
          bankBranchAddress: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankBranchAddress,
          bankAccount: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.bankAccount,
          ifscCode: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ifscCode,
          basicSalaryPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.basicSalaryPm,
          daPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.daPm,
          hraPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.hraPm,
          otherAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.otherAllowancePm,
          ltaPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ltaPm,
          medicalAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.medicalAllowancePm,
          washingAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.washingAllowancePm,
          specialAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.specialAllowancePm,
          fuelAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.fuelAllowancePm,
          entertainmentAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.entertainmentAllowancePm,
          educationAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.educationAllowancePm,
          booksAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.booksAllowancePm,
          statutoryBonusPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.statutoryBonusPm,
          anyOtherAllowancePm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.anyOtherAllowancePm,
          grossSalaryPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.grossSalaryPm,
          employeePfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.employeePfPm,
          employerPfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.employerPfPm,
          ptPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.ptPm,
          lwfPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.lwfPm,
          esicPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.esicPm,
          otherRetiralPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.otherRetiralPm,
          totalRetiralPm: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalRetiralPm,
          totalCTCIncludingRetiralPM: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalCTCIncludingRetiralPM,
          totalCTCIncludingRetiralPA: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.totalCTCIncludingRetiralPA,
          processOfVp: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.processOfVp,
          annualVariablePayBudget: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.annualVariablePayBudget,
          annualTotalCtc: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.annualTotalCtc,
          incrementOn: this.candidateGeneralAndSalaryinfo?.candidateSalaryInformation[0]?.incrementOn

        });
      }
      // this.callAppdd();
    })


  }


  hasError(controlName: string, errorType: string) {
    const control = this.employeeForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }
  subDepartment: any
  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close('Form Saved');
  }

  addDeptAndLoc(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '60%';
    dialogConfig.data = {
      popupName: popupName,
      // employeeData: this.getEmployeeCodeDataList
      employeeData: "this.getEmployeeCodeDataList"
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddDeptLocComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      this.getDepartmentsByCompany();
    });
  }
  getListOfBandNameOfComp: any = [];
  getListOfGradeNameOfComp: any = [];
  getListOfDesignationsOfComp: any = [];
  getListOfDepartmentsOfComp: any = [];
  getListOfSubDepartmentsOfComp: any = [];
  getListOfDesignationsAtDOJOfComp: any = []
  assignReporteesDropdown: any = [];
  getAllEmployeeofCompany: any = [];
  getListOfCompanyNameOfComp: any = []
  callAppdd() {
    this.getAllEmployeeDropdownByCompanyID();
    this.getBandsByCompany();
    this.getGradeByCompany();
    this.getDesignationsByCompany();
    this.getDesignationsByCompany();
    this.getDepartmentsByCompany();
    this.getSubDepartmentByCompany();
    this.getDesignationsAtDOJByCompany();
    this.getCompanyNameByCompany();
    this.getLocationListForPrifix();
    this.getAllEmployeeCodeData();
    this.getBankNameByCompany();
    this.getEmployeeListCode();
    this.getGroupNameByCompany();
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        this.assignReporteesDropdown = [];
        data?.data?.users.forEach((ele: any) => {
          if (ele) {
            let obj = {
              id: ele.id,
              name: ele.firstName + ' ' + ele.lastName,
              empCode: ele.empCode
            }
            this.assignReporteesDropdown.push(obj);
          }
        });
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          }
          this.getAllEmployeeofCompany.push(obj);
        });

      }, (error: any) => {
      }, () => { });
  }
  getBandsByCompany() {
    this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfBandNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfBandNameOfComp.push(obj);
      });
      this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getGradeByCompany() {
    this.httpService.callGetService(this.config.getGradesByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGradeNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGradeNameOfComp.push(obj);
      });
      this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsByCompany() {
    this.httpService.callGetService(this.config.getDesignationsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsOfComp.push(obj);
      });
      this.getListOfDesignationsOfComp = this.getListOfDesignationsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  // getDepartmentsByCompany() {
  //   this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.getListOfDepartmentsOfComp = [];
  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         id: ele,
  //         name: ele,
  //       }
  //       this.getListOfDepartmentsOfComp.push(obj);
  //     });
  //     this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
  //   })
  // }

  arrAllDepartmentCode: any = [];
  deptrecord: any = []
  CombineDeptArray: any = []
  tableDataForDept: any = [];
  updatedListData: any = [];
  DeptNewAddedrecord: any = [];
  getDepartmentsByCompany() {



    this.httpService.callGetService(`${this.config.getDepartmentListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`,).subscribe((resp: any) => {
      this.arrAllDepartmentCode = [];
      this.arrAllDepartmentCode = resp.data;

    })
    setTimeout(() => {

      this.httpService.callGetService(`${this.config.getDepartment}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {

        this.deptrecord = record.data;
        this.tableDataForDept = this.deptrecord.map((elm: any) => {
          const department = elm; // Ensure department is a valid any
          return {
            department: department, // Ensure the department is assigned properly
            deptCode: null, // Assign extracted two-letter code
            finalCode: null, // Assign extracted two-letter code
          };
        });


        this.updatedListData = this.tableDataForDept?.map((dept: any) => {

          const deptNames = this.tableDataForDept?.map((d: any) => d.department) || []; // Extract department names from dept array

          // Filter departments that are in NotmatchingData but NOT in deptNames
          const data = this.arrAllDepartmentCode.filter((elm: any) => !deptNames.includes(elm.departmentName));

          this.DeptNewAddedrecord = data?.map((elm: any) => {
            return {
              department: elm?.departmentName, // Ensure the department is assigned properly
              deptCode: elm?.departmentPrefix, // Assign extracted two-letter code
              departmentId: elm?.departmentId,
            }

          })
          const matchingData = this.arrAllDepartmentCode?.find((data: any) => data?.departmentName === dept?.department);


          // Update the limit for the matching band or set it to null for non-matching bands
          return {
            ...dept,
            // department: matchingBand ? matchingBand.departmentName : null,

            departmentId: matchingData ? matchingData.departmentId : null,
            deptCode: matchingData ? matchingData.departmentPrefix : null,
            finalCode: matchingData ? matchingData.finalCode : null, // Use amountLimit if matching, otherwise null
          };
        });
        this.CombineDeptArray = [...this.updatedListData, ...this.DeptNewAddedrecord];

      })


    }, 100)
    // console.log(this.updatetableDataForLoca);

  }
  getBankNameList: any = []
  getBankNameByCompany() {
    this.httpService.callGetService(this.config.getBankNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getBankNameList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBankNameList.push(obj);
      });
      this.getBankNameList = this.getBankNameList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCompanyNameByCompany() {
    this.httpService.callGetService(this.config.getCompanyNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCompanyNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCompanyNameOfComp.push(obj);
      });
      this.getListOfCompanyNameOfComp = this.getListOfCompanyNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getSubDepartmentByCompany() {
    this.httpService.callGetService(this.config.getSubDepartmentByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfSubDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfSubDepartmentsOfComp.push(obj);
      });
      this.getListOfSubDepartmentsOfComp = this.getListOfSubDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
    'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim',
    'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
    'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
    'Delhi', 'Puducherry', 'Ladakh', 'Jammu and Kashmir'
  ];
  getDesignationsAtDOJByCompany() {
    this.httpService.callGetService(this.config.getDesignationsAtDOJByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsAtDOJOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsAtDOJOfComp.push(obj);
      });
      this.getListOfDesignationsAtDOJOfComp = this.getListOfDesignationsAtDOJOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  getListOfGroupNameOfComp: any = []
  getGroupNameByCompany() {
    this.httpService.callGetService(this.config.getGroupNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGroupNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGroupNameOfComp.push(obj);
      });
      this.getListOfGroupNameOfComp = this.getListOfGroupNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }

  arrAllLocationList: any = []
  getLocationListForPrifix() {
    this.httpService.callGetService(`${this.config.getLocationListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`,).subscribe((resp: any) => {
      this.arrAllLocationList = [];
      console.log(resp.data);
      this.arrAllLocationList = resp.data;

    })
  }

  getEmployeeCodeDataList: any = [];
  selectedDeptLocation: any;
  getAllEmployeeCodeData() {
    this.httpService.callGetService(`${this.config.getAllEmployeeCode}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`).subscribe((resp: any) => {
      this.getEmployeeCodeDataList = resp?.data[0];
      this.setPrefix = this.getEmployeeCodeDataList?.companyPrefix;
      this.setLimit = this.getEmployeeCodeDataList?.startNumber;
      this.isManual = this.getEmployeeCodeDataList?.isManual;
      this.selectedDeptLocation = this.getEmployeeCodeDataList?.employeeCodeSelection;
    })
  }

  onSelectionOfHod() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['hodName'].value);
    this.employeeForm.controls['hodCode'].setValue(data?.empCode);
  }
  onSelectionOfManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['reportingManagerName'].value);
    this.employeeForm.controls['reportingManagerCode'].setValue(data?.empCode);
  }
  onSelectionOfDottedManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeeForm.controls['dottedReportingManagerName'].value);
    this.employeeForm.controls['dottedReportingManagerCode'].setValue(data?.empCode);
  }
  addSubmitForm: boolean = false;

  SaveCurrentemployeerelatedInfo() {
    let data = this.employeeForm.value;
    console.log(this.employeeForm.controls)
    if (this.employeeForm.invalid) {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
    }
    console.log(this.loggedInUserCompanyID);
    let depetMent = data.department?.label || data.department

    // let fromData = {
    //   "fiscalYear": this.loggedInCompanyFiscalyear,
    //   "year": this.selectedYearForCompetency,
    //   "companyId": this.loggedInUserCompanyID,
    //   "candidateId": this.candidateDetails.candidateId,
    //   "employmentCategory": data?.employmentCategory,
    //   "employmentType": data.employmentType,
    //   "retirementAge": data.retirementAge,
    //   "empStatus": data.empStatus,
    //   "dateOfJoining": data.dateOfJoining,
    //   "groupName": data.groupName||data.groupName?.label,
    //   "companyName": data.companyName|| data.companyName?.label,
    //   "reportingManagerName": String(data.reportingManagerName)|| data.reportingManagerName?.label,
    //   "reportingManagerCode": data.reportingManagerCode,
    //   "dottedReportingManagerName": data.dottedReportingManagerName|| data.dottedReportingManagerName?.label,
    //   "dottedReportingManagerCode": data.dottedReportingManagerCode,
    //   "hodName": String(data.hodName)|| data.hodName?.label,
    //   "hodCode": data.hodCode,
    //   "band": data.band|| data.band?.label,
    //   "grade": data.grade|| data.grade?.label,
    //   "designation": data.designation.label ||data.designation,
    //   "department": depetMent,
    //   "subDepartment": data.subDepartment,
    //   "workLocationState": data.workLocationState|| data.workLocationState?.label,
    //   "workLocationCity": data.workLocationCity,
    //   "designationAtDoj": data.designationAtDoj|| data.designationAtDoj?.label,
    //   "noOfPromotions": data.noOfPromotions,
    //   "currentPerformanceScore": data.currentPerformanceScore,
    //   "currentPerformanceRating": data.currentPerformanceRating,
    //   "lastYearPerformanceScore": data.lastYearPerformanceScore,
    //   "lastYearPerformanceRating": data.lastYearPerformanceRating,
    //   "yearBeforeLastYearPerformanceScore": data.yearBeforeLastYearPerformanceScore,
    //   "yearBeforeLastYearPerformanceRating": data.yearBeforeLastYearPerformanceRating,

    //   "mailBody": "Please review the submitted form for further processing.",
    //   "mailSubject": "Candidate Employment Form Submission"
    // }

    let fromData = {
      fiscalYear: this.loggedInCompanyFiscalyear,
      year: this.selectedYearForCompetency,
      companyId: this.loggedInUserCompanyID,
      candidateId: this.candidateDetails?.candidateId ?? null,
      employmentCategory: data?.employmentCategory ?? null,
      employmentType: data?.employmentType ?? null,
      retirementAge: data?.retirementAge ?? null,
      empStatus: data?.empStatus ?? null,
      dateOfJoining: data?.dateOfJoining ?? null,
      groupName: data?.groupName?.label ?? data?.groupName ?? null,
      companyName: data?.companyName?.label ?? data?.companyName ?? null,
      reportingManagerName: String(data?.reportingManagerName),
      reportingManagerCode: data?.reportingManagerCode ?? null,
      dottedReportingManagerName: data?.dottedReportingManagerName,
      dottedReportingManagerCode: data?.dottedReportingManagerCode ?? null,
      hodName: String(data?.hodName),
      hodCode: data?.hodCode ?? null,
      band: data?.band?.label ?? data?.band ?? null,
      grade: data?.grade?.label ?? data?.grade ?? null,
      designation: data?.designation?.label ?? data?.designation ?? null,
      department: depetMent ?? null, // Ensure `depetMent` is defined in the scope
      subDepartment: data?.subDepartment ?? null,
      workLocationState: data?.workLocationState?.label ?? data?.workLocationState ?? null,
      workLocationCity: data?.workLocationCity ?? null,
      designationAtDoj: data?.designationAtDoj?.label ?? data?.designationAtDoj ?? null,
      noOfPromotions: data?.noOfPromotions ?? 0,
      currentPerformanceScore: data?.currentPerformanceScore ?? 0,
      currentPerformanceRating: data?.currentPerformanceRating ?? null,
      lastYearPerformanceScore: data?.lastYearPerformanceScore ?? 0,
      lastYearPerformanceRating: data?.lastYearPerformanceRating ?? null,
      yearBeforeLastYearPerformanceScore: data?.yearBeforeLastYearPerformanceScore ?? 0,
      yearBeforeLastYearPerformanceRating: data?.yearBeforeLastYearPerformanceRating ?? null,
      mailBody: "Please review the submitted form for further processing.",
      mailSubject: "Candidate Employment Form Submission"
    };

    let banckName = data.bankName?.label || data.bankName
    let fromDataForSalary = {

      "hrId": this.loggedInUserId,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency,
      "companyId": this.loggedInUserCompanyID,
      "candidateId": this.candidateDetails.candidateId,
      "currency": data.currency,
      "salaryStatus": data.salaryStatus,
      "bankName": banckName,
      "bankBranchAddress": data.bankBranchAddress,
      "bankAccount": data.bankAccount,
      "ifscCode": data.ifscCode,
      "basicSalaryPm": data.basicSalaryPm,
      "daPm": data.daPm,
      "hraPm": data.hraPm,
      "otherAllowancePm": data.otherAllowancePm,
      "ltaPm": data.ltaPm,
      "medicalAllowancePm": data.medicalAllowancePm,
      "washingAllowancePm": data.washingAllowancePm,
      "specialAllowancePm": data.specialAllowancePm,
      "fuelAllowancePm": data.fuelAllowancePm,
      "entertainmentAllowancePm": data.entertainmentAllowancePm,
      "educationAllowancePm": data.educationAllowancePm,
      "booksAllowancePm": data.booksAllowancePm,
      "statutoryBonusPm": data.statutoryBonusPm,
      "anyOtherAllowancePm": data.anyOtherAllowancePm,
      "grossSalaryPm": data.grossSalaryPm,
      "employeePfPm": data.employeePfPm,
      "employerPfPm": data.employerPfPm,
      "ptPm": data.ptPm,
      "lwfPm": data.lwfPm,
      "esicPm": data.esicPm,
      "otherRetiralPm": data.otherRetiralPm,
      "totalRetiralPm": data.totalRetiralPm,
      "totalCTCIncludingRetiralPM": data.totalCTCIncludingRetiralPM,
      "totalCTCIncludingRetiralPA": data.totalCTCIncludingRetiralPA,
      "processOfVp": data.processOfVp,
      "annualVariablePayBudget": data.annualVariablePayBudget,
      "annualTotalCtc": data.annualTotalCtc,
      "incrementOn": data.incrementOn
    }
    console.log(data.bankName);

    if (this.employeeForm.valid) {

      this.httpService.callPostService(this.config.createByHR, fromData).subscribe((data: any) => {
        if (data) {
          //------------------------------employee Code -------------------------------------------------------
          let filterdepat = this.arrAllDepartmentCode.filter((elm: any) => elm.departmentName == this.employeeForm.value.department);
          let filterlocation = this.arrAllLocationList.filter((elm: any) => elm.locationName == this.employeeForm.value.workLocationState);



          let employeecodeFromData = {
            // "id":9,
            "companyId": this.loggedInUserCompanyID,
            "changeByUserId": this.loggedInUserId,
            "companyCodeId": this.getEmployeeCodeDataList?.companyCodeId, // FROM 1ST TABLE COMPANY_CODE  // FROM 1ST TABLE COMPANY_CODE 
            "manual": false,
            "employeeCodeSelection": this.selectedDeptLocation, // OPTIONS : DEPARTMENT, LOCATION, BOTH
            "prefix": this.setPrefix,
            "locationName": filterlocation[0]?.locationName,
            "departmentName": filterdepat[0]?.departmentName,
            "startNumber": this.setLimit,
            "locationCode": filterlocation[0]?.locationPrefix,
            "departmentCode": filterdepat[0]?.departmentPrefix,
            "candidateId": this.candidateDetails?.candidateId,
            //  "finalCode": "EMP0001NYCHR",
            "year": this.selectedYearForCompetency,
            "fiscalYear": this.loggedInCompanyFiscalyear

          }
          this.httpService.callPostService(this.config.employeeFinalCode, employeecodeFromData).subscribe((data: any) => {

          })
        }
      })
      this.httpService.callPostService(this.config.createByHRsalary, fromDataForSalary).subscribe((data: any) => {
        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // this.dialogRef.close();
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      )
    }

  }

  calculateAgeFromDOB() {
    const dob = new Date(this.employeeForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.employeeForm.controls['age'].setValue(age);
  }
  employeecodeData: any = []
  getEmployeeListCode() {
    this.httpService.callGetService(`${this.config.eployeeCodeList}?companyId=${this.loggedInUserCompanyID}&candidateId=${this.candidateDetails.candidateId}&year=${this.selectedYearForCompetency}`).subscribe((record: any) => {
      let data = record.data;
      this.employeecodeData = data.filter((elm: any) => elm.candidateId == this.candidateDetails.candidateId || elm.departmentName == this.employeeForm.value.department || elm.locationName == this.employeeForm.value.workLocationState)
    })
  }
  updateAllFrom() {
    let data = this.employeeForm.value;
    console.log(data.department);
    console.log(this.loggedInUserCompanyID);
    console.log(data.employmentType);
    let depetMent = data.department.label || data.department
    const updaeteFromdata = {
      salutation: data.salutation,
      firstName: data.firstName,
      lastName: data.lastName,
      gender: data.genders,  // Matching "data.gender" with "genders"
      country: data.country,
      address: data.presentAddress,
      permanentAddress: data.permanentAddress,
      maritalStatus: data.maritalStatus,
      dateOfBirth: data.dateOfBirth,
      age: data.age,
      personalEmail: data.personalEmail,
      aadharNo: data.aadhaarCardNo,  // Matching "data.aadharNo" with "aadhaarCardNo"
      panNo: data.panNo,
      uan: data.unaNo,  // Matching "data.uan" with "unaNo"
      contactNo: data.mobileNo,
      totalExperience: data.previousExperience,  // Matching "data.totalExperience" with "previousExperience"
      emergencyContactNo: data.emergencyContact,
      bloodGroup: data.bloodGroup,
      fathersName: data.fathersName,
      mothersName: data.mothersName,
      spouseName: data.spouseName,
      noOfChildren: data.noOfChildren,
      isRelativeWorking: data.relativeWorking == 'No' ? false : true,

      // Education Related Information
      highestEducationQualification: data.highestEducation,
      highestEducationInstitute: data.highestEducationInstitute,
      highestEducationYearOfPassing: data.highestEducationYear,
      highestEducationMarks: data.highestEducationMarks,
      highestEducationQualification2: data.secondEducation,
      highestEducationInstitute2: data.secondEducationInstitute,
      highestEducationYearOfPassing2: data.secondEducationYear,
      highestEducationMarks2: data.secondEducationMarks,
      highestEducationQualification3: data.thirdEducation,
      highestEducationInstitute3: data.thirdEducationInstitute,
      highestEducationYearOfPassing3: data.thirdEducationYear,
      highestEducationMarks3: data.thirdEducationMarks,
      highestProfessionalQualification: data.highestProfessional,
      highestProfessionalInstitute: data.highestProfessionalInstitute,
      highestProfessionalYearOfPassing: data.highestProfessionalYear,
      highestProfessionalMarks: data.highestProfessionalMarks,

      // Prior Employment Related Information
      lastOrganisationName: data.lastOrganisation,
      lastOrganisationDoj: data.lastOrganisationJoiningDate,
      lastOrganisationLwd: data.lastOrganisationLastWorkingDate,
      lastOrganisationDepartment: data.lastOrganisationDepartment,
      lastOrganisationDesignation: data.lastOrganisationDesignation,
      lastToLastOrganisationName: data.lastToLastOrganisation,
      lastToLastOrganisationDoj: data.lastToLastOrganisationJoiningDate,
      lastToLastOrganisationLwd: data.lastToLastOrganisationLastWorkingDate,
      lastToLastOrganisationDepartment: data.lastToLastOrganisationDepartment,
      lastToLastOrganisationDesignation: data.lastToLastOrganisationDesignation,
      otherOrganisationName: data.anyOtherOrganisation,
      otherOrganisationDoj: data.anyOtherOrganisationJoiningDate,
      otherOrganisationLwd: data.anyOtherOrganisationLastWorkingDate,
      otherOrganisationDepartment: data.anyOtherOrganisationDepartment,
      otherOrganisationDesignation: data.anyOtherOrganisationDesignation,

      //HR
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency,
      // "companyId": this.loggedInUserCompanyID,
      // "candidateId": this.candidateDetails.candidateId,
      "employmentCategory": data?.employmentCategory,
      "employmentType": data.employmentType,
      "retirementAge": data.retirementAge,
      "empStatus": data.empStatus,
      "dateOfJoining": data.dateOfJoining,
      "groupName": data.groupName.label || data.groupName,
      "companyName": data.companyName.label || data.companyName,
      "reportingManagerName": String(data.reportingManagerName) || data.reportingManagerName,
      "reportingManagerCode": data.reportingManagerCode,
      "dottedReportingManagerName": (data.dottedReportingManagerName) || data.dottedReportingManagerName,
      "dottedReportingManagerCode": data.dottedReportingManagerCode,
      "hodName": String(data.hodName) || data.hodName,
      "hodCode": data.hodCode,
      "band": data.band.label || data.band,
      "grade": data.grade.label || data.grade,
      "designation": data.designation.label || data.designation,
      "department": depetMent,
      "subDepartment": data.subDepartment,
      "workLocationState": data.workLocationState.label || data.workLocationState,
      "workLocationCity": data.workLocationCity,
      "designationAtDoj": data.designationAtDoj.label || data.designationAtDoj,
      "noOfPromotions": data.noOfPromotions,
      "currentPerformanceScore": data.currentPerformanceScore,
      "currentPerformanceRating": data.currentPerformanceRating,
      "lastYearPerformanceScore": data.lastYearPerformanceScore,
      "lastYearPerformanceRating": data.lastYearPerformanceRating,
      "yearBeforeLastYearPerformanceScore": data.yearBeforeLastYearPerformanceScore,
      "yearBeforeLastYearPerformanceRating": data.yearBeforeLastYearPerformanceRating,

      "mailBody": "Please review the submitted form for further processing.",
      "mailSubject": "Candidate Employment Form Submission",

      // salary
      // "hrId": this.loggedInUserId,

      "currency": data.currency,
      "salaryStatus": data.salaryStatus,
      "bankName": data.bankName || data.bankName.label,
      "bankBranchAddress": data.bankBranchAddress,
      "bankAccount": data.bankAccount,
      "ifscCode": data.ifscCode,
      "basicSalaryPm": data.basicSalaryPm,
      "daPm": data.daPm,
      "hraPm": data.hraPm,
      "otherAllowancePm": data.otherAllowancePm,
      "ltaPm": data.ltaPm,
      "medicalAllowancePm": data.medicalAllowancePm,
      "washingAllowancePm": data.washingAllowancePm,
      "specialAllowancePm": data.specialAllowancePm,
      "fuelAllowancePm": data.fuelAllowancePm,
      "entertainmentAllowancePm": data.entertainmentAllowancePm,
      "educationAllowancePm": data.educationAllowancePm,
      "booksAllowancePm": data.booksAllowancePm,
      "statutoryBonusPm": data.statutoryBonusPm,
      "anyOtherAllowancePm": data.anyOtherAllowancePm,
      "grossSalaryPm": data.grossSalaryPm,
      "employeePfPm": data.employeePfPm,
      "employerPfPm": data.employerPfPm,
      "ptPm": data.ptPm,
      "lwfPm": data.lwfPm,
      "esicPm": data.esicPm,
      "otherRetiralPm": data.otherRetiralPm,
      "totalRetiralPm": data.totalRetiralPm,
      "totalCTCIncludingRetiralPM": data.totalCTCIncludingRetiralPM,
      "totalCTCIncludingRetiralPA": data.totalCTCIncludingRetiralPA,
      "processOfVp": data.processOfVp,
      "annualVariablePayBudget": data.annualVariablePayBudget,
      "annualTotalCtc": data.annualTotalCtc,
      "incrementOn": data.incrementOn
    };
    console.log(this.employeeForm.controls);
    if (this.employeeForm.invalid) {
      this.addSubmitForm = true;
      this.employeeForm.markAllAsTouched();
    }


    if (this.employeeForm.valid) {
      this.httpService.callPutService(`${this.config.updateHRInfo}/${this.candidateDetails.candidateId}/companyId/${this.loggedInUserCompanyID}`, updaeteFromdata).subscribe((data: any) => {
        console.log(data);

        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          //------------------------------employee Code -------------------------------------------------------
          let filterdepat = this.arrAllDepartmentCode.filter((elm: any) => elm.departmentName == this.employeeForm.value.department);
          let filterlocation = this.arrAllLocationList.filter((elm: any) => elm.locationName == this.employeeForm.value.workLocationState);
          console.log(this.arrAllDepartmentCode);
          console.log(this.getEmployeeCodeDataList);

          let employeecodeFromData = {
            "id": this.employeecodeData[0]?.id,
            "companyId": this.loggedInUserCompanyID,
            "changeByUserId": this.loggedInUserId,
            "companyCodeId": this.getEmployeeCodeDataList?.companyCodeId, // FROM 1ST TABLE COMPANY_CODE 
            "manual": false,
            "employeeCodeSelection": this.selectedDeptLocation, // OPTIONS : DEPARTMENT, LOCATION, BOTH
            "prefix": this.setPrefix,
            "locationName": filterlocation[0]?.locationName,
            "departmentName": filterdepat[0]?.departmentName,
            "startNumber": this.setLimit,
            "locationCode": filterlocation[0]?.locationPrefix,
            "departmentCode": filterdepat[0]?.departmentPrefix,
            "candidateId": this.candidateDetails?.candidateId,
            //  "finalCode": "EMP0001NYCHR",
            "year": this.selectedYearForCompetency,
            "fiscalYear": this.loggedInCompanyFiscalyear

          }
          this.httpService.callPostService(this.config.employeeFinalCode, employeecodeFromData).subscribe((data: any) => {

          })

          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });


        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            // this.dialogRef.close();
            console.log('Error dialog closed');
          });
        }
      )

    }
  }

  onDepartmentChange(selectedValue: string) {
    // Check if the selected value exists in the department list
    console.log(selectedValue);


    const exists = this.CombineDeptArray.some((item: any) => item.department === selectedValue || item.department === selectedValue);

    if (!exists) {
      this.addDeptAndLoc(selectedValue);  // Open add department function
    }
  }

}
